module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABIElEQVQ4T+2TLUsEURSG3zP3yg3mrSarRlEwitUgKIjFL+7ONGF/wP4DYeGO9xYXQSxiEQSDWAWjybxli20wzDJnjsyAMiyGHZPB087H+3A+OIQpCyHcMvNlkiR3zZRzblNrba212804DQaDjjHGicgSgJcoihaY+ZGI9puFInKllNooy3IEYAXAiJmPyXt/D+BNRIZFUXwYYy6Y+RrA81Rza0qpvTzPD7XW80S0KyLLFEKQ8Xhs+v3+pBJ4789F5CaO46cmIE3TVaXUkbX25CteaWuAiPjpXcziE1G3BgA4nUXwQ81ZDbDW0m8A3yP8A/7CErMs6/R6vfc2pwwhzAGYVL/wQESvAEIbgIhsAdgh59yi1noIYL0NoHpAZj74BInWpJtn44KnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/date.png
// module id = 11fi
// module chunks = 96